<template>
  <a-select
      size="large"
      :placeholder="placeholder"
      :disabled="disabled"
      show-search
      :filter-option="false"
      @search="handleSearch"
      @dropdownVisibleChange="handleDropdownVisibleChange"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <a-select-option
        v-if="emptyOptionValue !== null"
        :value="emptyOptionValue"
        :key="emptyOptionValue"
    >
      {{ emptyOptionLabel }}
    </a-select-option>

    <a-select-option
        v-for="item in filteredOrganizationsList"
        :value="item.id"
        :key="item.id"
    >
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: 'SearchableOrganizationSelect',
  inheritAttrs: false,
  props: {
    organizations: {
      type: Array,
      required: true
    },
    emptyOptionValue: {
      type: [String, Number],
      default: null
    },
    emptyOptionLabel: {
      type: String,
      default: 'No organization'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select organization'
    }
  },
  data() {
    return {
      organizationSearchText: ''
    };
  },
  computed: {
    sortedOrganizations() {
      return [...this.organizations].sort((a, b) =>
          a.name.localeCompare(b.name)
      );
    },
    filteredOrganizationsList() {
      if (!this.organizationSearchText) {
        return this.sortedOrganizations;
      }
      const searchLower = this.organizationSearchText.toLowerCase();
      return this.sortedOrganizations.filter(org =>
          org.name.toLowerCase().includes(searchLower)
      );
    }
  },
  methods: {
    handleSearch(value) {
      this.organizationSearchText = value;
    },
    handleDropdownVisibleChange(open) {
      if (!open) {
        this.organizationSearchText = '';
      }
    }
  }
};
</script>